<template>
  <el-row class="cs-contentContainer">
    <el-col :span="4" class="cs-main-left-container">
      <navigator></navigator>
    </el-col>
    <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container" v-loading="loading">
      <div style class="cs-fullHeight cs-contentContainer-right">
        <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
          <el-row>
            <el-button type="text" size="medium" @click="onBack()">返回</el-button>
          </el-row>
          <el-row>
            <span class="cs-title">补款</span>
          </el-row>
          <hr>
          <el-row>
            <workflow-step3 ref="workflowStep3" :dataIn="step3Model" :workMode="'ContinuePayment'" @save="onSaveStep3"></workflow-step3>
          </el-row>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { getContinuPaymentViewModel } from "../../service/enrollmentFee.service.js";
import { arrayEquals, getCourseTypeText, toDecimal } from "../../config/mUtils";
import {saveContinuePayment,saveContinueAccountPayment} from "../../service/finance.service.js"
import {
  getBonusPointMechanismByType,
} from "../../service/bonusPoint.service";
import { getGlobalPriceSettings } from "../../service/globalPriceSetting.service";
import { getAllStudentAdvanceEnrollmentByStudentId } from "../../service/advanceEnrollment.service.js";
import navigator from "../../components/navigator";
import workflowStep3 from "../../components/addCollectFees/courseEnrollmentFee/workflowStep3";
export default {
  data() {
    return {
      loading:false,
      step3Model: {}, 
      step2Model: {},
      memberModel: {},
      workflowData: {},
      currentWorkflowId: 0,
      currentStudnetId: 0,
      priceSettings: {
        memberCardPrice: 0,
        adEnrollmentPrice: 0,
        paymentCommissionRate: 0, 
        bonusPointToMoney_Money: 0,
        bonusPointToMoney_BonusPoint: 0
      },
      studentAdvanceEnrollmentList:[],
      taxModel:{
        hasTaxSetting: false,
        hasTax: false,
        taxRate: 0,
        courseTotalTax: 0,
        isDoubleBonusPoint: false
      },
      debt: 0
    };
  },
  components: {
    workflowStep3,
    navigator
  },
  created() {
    this.currentStudnetId = this.$route.query.studentId;
    this.currentWorkflowId = this.$route.query.workflowId;
    this.loadPriceSettings();
    this.loadPaymentModel();
    
  },
  methods: {
    init() {
      if (!!this.workflowData && Object.keys(this.workflowData).length > 0 &&
      !!this.priceSettings && this.priceSettings.bonusPointToMoney_BonusPoint > 0 && this.priceSettings.adEnrollmentPrice > 0){
        this.initStepModel();
      }else{

      }
    },
    loadPaymentModel(){
      getContinuPaymentViewModel(
        this.currentWorkflowId,
        this.currentStudnetId
      ).then(result => {
        if (result && result.success) {
          this.memberModel = {
            memberModel: result.data.MemberInfo,
            hasBuyMemberCard: false
          };
          this.workflowData = result.data.WorkflowData;
          this.debt = result.data.Debt;
          this.workflowData.EnrollmentType = 2;
          this.discountList = result.data.DiscountList; 
          this.init();
        }
      });
    },
    getSelectedDiscountName() {
      let names = "";
      this.step2Model.selectedDiscountList.forEach(id => {
        let discount = this.discountList.filter(i => i.Id == id);
        if (discount.length > 0) {
          names += discount[0].LabelName;
        }
      });
      return names;
    },
    loadPriceSettings() {
      getBonusPointMechanismByType(2).then(result=>{
        if (result && result.success){
          this.priceSettings.bonusPointToMoney_Money = result.data.Money;
          this.priceSettings.bonusPointToMoney_BonusPoint = result.data.BonusPoint;
        }
        this.init();
      });
      getGlobalPriceSettings().then(result => {
        if (!!result && result.success) {
          this.priceSettings.memberCardPrice = this.findPriceByType(
            result.data,
            4
          );
          this.priceSettings.adEnrollmentPrice = this.findPriceByType(
            result.data,
            6
          );
          this.priceSettings.paymentCommissionRate = this.findPriceByType(
            result.data,
            5
          );
          this.priceSettings.trainingAdEnrollmentPrice = this.findPriceByType(
            result.data,
            10
          );
        }
        this.init();
      });
    },
    findPriceByType(gpSettings, type) {
      let result = null;

      for (let i = 0; i < gpSettings.length; i++) {
        let gpSetting = gpSettings[i];
        if (gpSetting.Type === type) {
          result = gpSetting;
          break;
        }
      }

      return result != null ? result.Value : 0;
    },
    async initStepModel() {
      await this.loadStudentAdvanceEnrollments();
      this.workflowOriginalData = JSON.parse(JSON.stringify(this.workflowData));
      this.activeStep = 3;

       this.taxModel = {
        hasTaxSetting: false,
        hasTax: this.workflowData.HasTax,
        courseTotalTax: this.workflowData.CourseTotalTax,
        taxRate: this.workflowData.TaxRate,
        isDoubleBonusPoint: this.workflowData.IsDoubleBonusPoint
      }

      this.initStep2Model();
      this.initStep3Model();
      this.loading = false;  
    },

    initStep2Model() {
      let enrollmentCount = 0;
      let trainingEnrollmentCount= 0;
      if (!!this.memberModel){
        enrollmentCount = this.memberModel.AdvanceEnrollmentCount - this.memberModel.AdvanceEnrollmentCountUsed;
        trainingEnrollmentCount = this.memberModel.TrainingAdvanceEnrollmentCount - this.memberModel.TrainingAdvanceEnrollmentCountUsed;
      }
      if (!!this.workflowData && this.workflowData.Id > 0) {
        let list = [];
        if (
          !!this.workflowData.WorkflowCourses &&
          this.workflowData.WorkflowCourses.length > 0
        ) {
          this.workflowData.WorkflowCourses.forEach(element => {
            let discountPrice = element.DiscountPrice;
            if (element.DiscountPriceBeforeCoupon){
              discountPrice = element.DiscountPriceBeforeCoupon;
            }
            let itemData = {
              modelData: {
                isAdvanceEnrollmentPrice: element.IsAdvanceEnrollmentPrice,
                isInternalPrice: element.IsInternalPrice,
                isOriginalPrice: element.IsOriginalPrice,
                isFreeTrial: element.IsFreeTrial,
                startWeek: element.StartWeek,
                categoryId: element.CourseCategoryId,
                categoryOptionId: element.CourseCategoryOptionId,
                vipCoursePriceId: element.VipCoursePriceId,
                courseCount: element.CourseCount,
                courseMinutes: element.CourseMinutes,
                supplementVideoType: element.SupplementVideoType,
                supplementVideoCount: element.SupplementVideoCount,
                contractId: element.ContractId,
                weChatGroupType: element.WeChatGroupType,
                comment: element.Comment,            
                yearCourseType: element.YearCourseType
              },
              priceData: {
                price: element.Price,
                discountPrice: discountPrice,
                couponDiscountPrice: element.DiscountPrice,
                subtotal: element.PaymentDiscountPrice,
                supplementVideoPrice: element.SupplementVideoPrice,
                changeCourseDifferentPrice: element.ChangeCourseDifferentPrice,
                changeCourseRefundPrice: element.ChangeCourseRefundPrice,
                changeCourseRefundBalance: element.ChangeCourseRefundBalance,
              },
              courseId: element.CourseId,
              courseName: element.CourseName,
              courseType: element.CourseType,
              courseTypeText: getCourseTypeText(element.CourseType),
              universityGroup: this.memberModel.UniversityGroupNumber,
              universityGroupText: this.memberModel.UniversityGroupText,
              termId: this.workflowData.TermId,
              termText: this.workflowData.TermText,
              categoryId: this.workflowData.CategoryId,
              categoryText: this.workflowData.CategoryText,
              campusId: element.CampusId,
              campusText: element.CampusText,
              isRefund: element.IsRefund,
              isHourPrice: false,
              isYearCourse: element.IsYearCourse,
              yearCourseType: element.YearCourseType
            };

            if (element.CourseType == 2){
              itemData.isHourPrice = element.IsHourPrice;
            }

            list.push(itemData);
          });
        }
        let courseListData = {
          termId: this.workflowData.TermId,
          enrollmentAvailableCount: enrollmentCount,
          trainingEnrollmentAvailableCount: trainingEnrollmentCount,
          courseList: list
        };

        this.step2Model = {
          isCompleted: this.workflowData.IsCompleted,
          courseType : this.workflowData.CourseType,
          hasBuyMemberCard: this.hasBuyMemberCard,
          universityGroupNumber: this.memberModel.UniversityGroupNumber,
          universityGroupText: this.memberModel.UniversityGroupText,
          selectedDiscountList: this.workflowData.WorkflowDiscounts.map(i => {
            return i.FormulaFieldId;
          }),
          courseListData: courseListData,
          taxModel: this.taxModel
        };
      } else {
        this.step2Model = {
          isCompleted: false,
          courseType: 1,
          hasBuyMemberCard: this.hasBuyMemberCard,
          universityGroupNumber: this.memberModel.UniversityGroupNumber,
          universityGroupText: this.memberModel.UniversityGroupText,
          selectedDiscountList: [],
          courseListData: {
            termId: 0,
            courseList: []
          },
          taxModel: this.taxModel
        };
      }
    },
    initStep3Model() {
      let enrollmentCountUsed = this.step2Model.courseListData.courseList.filter(
        i => i.isAdvanceEnrollmentPrice
      ).length;
      let memberCardDiscountPrice = this.workflowData.BuyMemberCardPrice;
      let enrollmentCount =
        this.workflowData.AdvanceEnrollmentCount - enrollmentCountUsed;
      let discountName = this.getSelectedDiscountName();

      let accountType = 2;
      if (this.workflowData.CourseType == 2){
        accountType = 10;
      }
      else if (this.workflowData.CourseType == 3){
        accountType = 9;
      }

      let model = {
        isContinuePayment: true,
        debt: this.debt,
        isCompleted: this.workflowData.IsCompleted,
        discountName: discountName,
        accountType: accountType,
        courseType: this.workflowData.CourseType,
        workflowId: this.workflowData.Id,
        balanceInStore: this.workflowData.BalanceInStore,
        courseDiscountTotalPrice: this.workflowData.CourseDiscountTotalPrice,
        advanceEnrollmentTotalPrice: this.workflowData.AdvanceEnrollmentPrice + this.workflowData.AdvanceEnrollmentPriceTax,
        advanceEnrollmentTotalPriceTax: this.workflowData.AdvanceEnrollmentPriceTax,
        workflowRelatedDicountAmount: this.workflowData.WorkflowRelatedDicountAmount,
        changeCourseDifferentPriceTotal: this.workflowData.ChangeCourseDifferentPriceTotal,
        changeCourseRefundPriceTotal: this.workflowData.ChangeCourseRefundPriceTotal,
        memberModel: this.memberModel.memberModel,
        enrollmentCountUsed: enrollmentCountUsed,
        priceSettings: this.priceSettings,
        memberCardModel: {
          hasBuyMemberCard: this.hasBuyMemberCard,
          memberCardDiscountPrice: memberCardDiscountPrice
        },
        modelData: {
          enrollmentCount: enrollmentCount,
          balance:this.workflowData.BalanceCost + this.workflowData.BalanceCostTax,
          balanceTax: this.workflowData.BalanceCostTax,
          bonusPoint: this.workflowData.BonusPointCost,
          cashDecreased: this.workflowData.CashDecreasedAmount,
          couponDiscountDollar: this.workflowData.CouponDiscountDollar,
          studentAdvanceEnrollmentAdditional: this.workflowData.StudentAdvanceEnrollmentAdditional,
          comment: this.workflowData.Comment,
          isAutonomousEnrolment: this.workflowData.IsAutonomousEnrolment,
          isAutonomousPayment: false,
          paymentType: null,
          qrCodeImage: null,
          currentAutonomousPaymentRecordId: null
        },
        studentAdvanceEnrollmentList: this.studentAdvanceEnrollmentList,
        courseList: this.step2Model.courseListData.courseList,
        taxModel: this.taxModel,
        couponData:{
          couponCode: this.workflowData.CouponCode,
          couponDiscountValue: this.workflowData.CouponDiscountValue
        }
      };
      this.step3Model = model;
      this.step3Model.isCompleted = false;
      this.step3Model.isSupplement = true; 
      //暂时禁用删除付款
      this.step3Model.disabledRemove = true;

      let currentAPRecord = this.workflowData.AutonomousPaymentRecords.find(item => item.Id == this.workflowData.CurrentAutonomousPaymentRecordId && item.IsSupplement && item.Status !== 3);
      if (!!currentAPRecord) {
        model.modelData.isAutonomousPayment = true;
        model.modelData.paymentType = currentAPRecord.PaymentType;
        model.modelData.qrCodeImage = currentAPRecord.QRCodeImage;
        model.modelData.currentAutonomousPaymentRecordId = currentAPRecord.Id;
      }
    },
    async onSaveStep3() {  
      this.loading = true;
      this.setValueForWorkflowModel();    
      let result = await saveContinuePayment(this.workflowData);
      if (result && result.success){
        this.workflowData.Id = result.data;
        this.workflowOriginalData = JSON.parse(JSON.stringify(this.workflowData)); 
        this.loadPaymentModel();
      }else{ 
        this.$message({
          message: result.message,
          type: "error"
        });
        this.loading = false;  
      }
      
      return true;
    },
    onAddPaymentEditorCallback(data){
       saveContinueAccountPayment(data).then(result=>{

       })
    },
    setAdvanceEnrollmentTotalPriceForWorkflowModel(){
      this.workflowData.AdvanceEnrollmentPrice = this.step3Model.advanceEnrollmentTotalPrice - this.step3Model.advanceEnrollmentTotalPriceTax;
      this.workflowData.AdvanceEnrollmentPriceTax = this.step3Model.advanceEnrollmentTotalPriceTax;
    },
    setValueForWorkflowModel(){  
      this.workflowData.AdvanceEnrollmentCount = parseInt(this.step3Model.modelData.enrollmentCount);
      this.workflowData.BalanceCost = toDecimal(this.step3Model.modelData.balance - this.step3Model.modelData.balanceTax, 4);
      this.workflowData.BalanceCostTax = this.step3Model.modelData.balanceTax;
      this.workflowData.BonusPointAmount = this.step3Model.modelData.bonusPointAmount;
      this.workflowData.BonusPointCost = this.step3Model.modelData.bonusPoint;
      this.workflowData.CashDecreasedAmount = this.step3Model.modelData.cashDecreased;
      this.workflowData.StudentAdvanceEnrollmentAdditional = this.step3Model.modelData.studentAdvanceEnrollmentAdditional;
      this.workflowData.Comment = this.step3Model.modelData.comment; 

      this.setAdvanceEnrollmentTotalPriceForWorkflowModel();
    },
    onBack(){
        this.$router.back(-1);
    },
    async loadStudentAdvanceEnrollments() {
      await getAllStudentAdvanceEnrollmentByStudentId(this.currentStudnetId).then(result => {
        if (!!result && result.success) {
          this.studentAdvanceEnrollmentList = result.data;
        }
      });

    },
  }
};
</script>



// WEBPACK FOOTER //
// src/page/frontDesk/salesQueryContinuePayment.vue